
import * as defaultImport from "@splunk/react-icons/InformationDiamond";
export * from "@splunk/react-icons/InformationDiamond";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
